import React, { Component } from 'react';

import Constants from '../Constants';
import ScheduleLink from './ScheduleLink';
import ScoreChart from './ScoreChart';

import '../styles/RulesPanel.css';

class RulesPanel extends Component {
  render() {
    return (
      <div className="rules-panel">
        <div className="rules-panel-group">
          <h2 className="rules-panel-heading">How to Play</h2>
          <div className="rules-panel-section">
            On each turn, select one of the letter options and enter it into the grid.
          </div>
          <div className="rules-panel-section">
            Unchosen letters do not carry over; you&#39;ll get a new set of letters each turn.
          </div>
          <div className="rules-panel-section">
            In each row and column, the best-scoring word counts. A word scores based on its length:
            <ScoreChart />
          </div>
          <div className="rules-panel-section">
            In games with holds, unused held tiles cost you {-Constants.PENALTY_HOLD} points each, so make sure to use them!
          </div>
          <div className="rules-panel-section">
            Ten Words uses Scrabble's <cite>Official Tournament and Club Word List, 2006 Edition</cite>.
          </div>
        </div>
        <div className="rules-panel-group">
          <h2 className="rules-panel-heading">The Daily</h2>
          <div className="rules-panel-section">
            Everyone who plays the daily gets the same set of letters, and scores are recorded on the leaderboard.
          </div>
          <div className="rules-panel-section">
            You get only <span className="span-bold">one attempt</span> at the daily game each day (Eastern time).
          </div>
          <div className="rules-panel-section">
            <ScheduleLink onClick={this.props.onScheduleClick} />
          </div>
        </div>
        <div className="rules-panel-group">
          <h2 className="rules-panel-heading">Free Play</h2>
          <div className="rules-panel-section">
            Free play mode has no play count restriction—play as much as you like!
          </div>
        </div>
      </div>
    );
  }
}

export default RulesPanel;
